<template>
  <div v-if="value">
    <h2>{{ $t('pick.a.ticket') }}</h2>
    <form
      id="form-choose-table"
    >
      <p>{{ $t('pick.a.ticket.description') }}.</p>

      <div class="input-group">
        <div
          class="input input-text"
        >
          <label
            class="sr-only"
            for="ticket-number"
          >{{ $t('name') }}</label>
          <input
            id="ticket-number"
            v-model="ticketText"
            type="text"
            placeholder="A 001"
            required
          >
        </div>
        <span
          v-show="err.active"
          class="error-message"
        >
          {{ err.message }}
        </span>
      </div>

      <div
        v-if="ticket"
        class="label-ticket"
      >
        <div class="l-flex l-flex--center">
          <div class="avatar label-ticket__avatar">
            <img
              v-if="ticket.assignedTo !== null"
              :src="`https://fenix.tecnico.ulisboa.pt/user/photo/${ticket.assignedTo}`"
            >
            <svg
              v-else
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
            >
              <g
                fill="none"
                fill-rule="evenodd"
              >
                <circle
                  cx="16"
                  cy="16"
                  r="16"
                  fill="#2E3242"
                  opacity=".37999999"
                />
                <path
                  fill="#FFF"
                  d="M14.772 18.842c-.0600003-.408002-.0450004-.7799983.045-1.116.0900004-.3360017.2189992-.6479986.387-.936.1680008-.2880014.356999-.5519988.567-.792.210001-.2400012.410999-.4709989.603-.693.192001-.2220011.3509994-.437999.477-.648.1260006-.2100011.189-.4289989.189-.657 0-.3720019-.1109989-.653999-.333-.846-.2220011-.192001-.5129982-.288-.873-.288-.3360017 0-.6329987.0779992-.891.234s-.5069988.3539988-.747.594l-1.458-1.332c.408002-.4920025.8879972-.8879985 1.44-1.188.5520028-.3000015 1.1639966-.45 1.836-.45.5040025 0 .9749978.0599994 1.413.18.4380022.1200006.8159984.3059987 1.134.558.3180016.2520013.5669991.572998.747.963.1800009.3900019.27.8489974.27 1.377 0 .3720019-.0659993.7049985-.198.999-.1320007.2940015-.296999.5669987-.495.819-.198001.2520013-.4079989.4949988-.63.729-.2220011.2340012-.4259991.4769987-.612.729-.1860009.2520013-.3329995.5189986-.441.801-.1080005.2820014-.1440002.6029982-.108.963h-2.322zm-.432 2.718c0-.4800024.1499985-.8789984.45-1.197.3000015-.3180016.6779977-.477 1.134-.477.4560023 0 .8369985.1589984 1.143.477.3060015.3180016.459.7169976.459 1.197 0 .4680023-.1529985.8609984-.459 1.179-.3060015.3180016-.6869977.477-1.143.477-.4560023 0-.8339985-.1589984-1.134-.477-.3000015-.3180016-.45-.7109977-.45-1.179z"
                />
              </g>
            </svg>
          </div>

          <div
            v-if="!ticket || ticket.assignedTo === null"
            class=""
          >
            <div
              class="label-ticket__username"
            >
              Desconhecido
            </div>
            <button
              v-if="ticket.state !== 'solved'"
              class="link link--blue"
            >
              Associar Técnico ID
            </button>
          </div>
          <div
            v-else
            class=""
          >
            <div
              v-if="currentUser && currentUser.name"
              class="label-ticket__username"
            >
              {{ currentUser.name | formatName }}
            </div>
            <div class="">
              {{ ticket.assignedTo }}
            </div>
          </div>
        </div>

        <div class="l-flex l-flex--col l-flex--end">
          <div class="ticket-letter">
            {{ ticket.letter }} {{ ticket.number }}
          </div>
          <div>{{ ticket.state | ticketStateFilter }}</div>
        </div>
      </div>

      <div class="form-actions">
        <button
          type="button"
          class="btn-secondary"
          @click="close()"
        >
          {{ $t('cancel') }}
        </button>
        <button
          id="confirm-choose-table"
          :disabled="btnDisabled"
          type="button"
          class="btn-primary btn-active main-action"
          @click="TakeTicket()"
        >
          {{ $t('pick.ticket') }}
        </button>
      </div>
    </form>
  </div>
</template>
<script>
import tickets from '@/api/tickets'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'TakeTicket',
  filters: {
    ticketStateFilter: function (state) {
      if (state === 'skipped' || state === 'created') {
        return 'Por atender'
      } else if (state === 'attending' || state === 'solved') {
        return 'Atendida'
      } else if (state === 'paused') {
        return 'Em pausa'
      }
    },
    formatName (name) {
      let names = name.split(' ')
      name = name.trim()
      if (names.length < 3) {
        return name
      }
      return `${names[0]} ${names[names.length - 1]}`
    }
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    serviceID: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      open: false,
      ticket: undefined,
      ticketText: '',
      err: {
        active: false,
        message: 'Este campo é obrigatório!'
      },
      btnDisabled: true
    }
  },
  computed: {
    ...mapState([
      'loggedUser',
      'currentUser',
      'currentTicket'
    ])
  },
  watch: {
    ticketText: function (ticketText, oldticketText) {
      let number, letter
      if (this.timeout) {
        clearTimeout(this.timeout)
      }
      this.timeout = setTimeout(async () => {
        letter = this.ticketText.substring(0, 1)
        if (letter.match(/[a-z]/i) === null) {
          this.err.active = true
          this.btnDisabled = true
          this.ticket = undefined
          this.err.message = 'A letra de fila que introduziu não é válida'
          return
        }
        number = Number(this.ticketText.substring(1, this.ticketText.length))
        if (Number.isNaN(number)) {
          this.err.active = true
          this.btnDisabled = true
          this.ticket = undefined
          this.err.message = 'O numero que introduziu não é válido'
          return
        }
        try {
          this.ticket = await tickets.getTicket({ service: this.serviceID, letter, ticketNumber: number })
          this.fetchFenixUser({ username: this.ticket.assignedTo })
          this.err.active = false
          if (this.ticket.state === 'created' || this.ticket.state === 'skipped') {
            this.btnDisabled = false
          } else {
            this.btnDisabled = true
          }
        } catch (error) {
          if (error.response && error.response.status === 400) {
            this.ticket = undefined
            this.err.message = 'A senha que indicou não existe'
          } else if (error.response && error.response.status === 404) {
            this.ticket = undefined
            this.err.message = 'A senha que introduziu não existe ou já foi arquivada.'
          }
          this.btnDisabled = true
        }
      }, 800)
    }
  },
  created () {
    this.clearFenixUser()
  },
  async mounted () {
    this.clearFenixUser()
  },
  methods: {
    ...mapActions([
      'fetchCurrentTicket',
      'fetchFenixUser',
      'clearFenixUser',
      'fetchNextTickets',
      'fetchTicketsWaitingCount'
    ]),
    async close () {
      this.$emit('input', false)
    },
    async TakeTicket () {
      await tickets.takeTicket({ number: this.ticket.number, serviceID: this.serviceID, queueSlug: this.ticket.letter })
      await this.fetchCurrentTicket(this.serviceID)
      await tickets.attendTicket({ service: this.serviceID, queueSlug: this.currentTicket.letter, ticket: this.currentTicket.id })
      await this.fetchCurrentTicket(this.serviceID)
      this.fetchNextTickets(this.serviceID)
      this.fetchTicketsWaitingCount(this.serviceID)
      this.close()
    }
  }
}
</script>
<style lang="scss" scoped>
.ticket-letter {
  text-transform: uppercase;
}
</style>
